import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import CreateAttachmentInlineType from 'owa-service/lib/contract/CreateAttachmentInlineType';
import CreateAttachmentResponse from 'owa-service/lib/contract/CreateAttachmentResponse';
import Item from 'owa-service/lib/contract/Item';
import ItemId from 'owa-service/lib/contract/ItemId';
import createAttachmentJsonRequest from 'owa-service/lib/factory/createAttachmentJsonRequest';
import createAttachmentRequest from 'owa-service/lib/factory/createAttachmentRequest';
import itemIdAttachment from 'owa-service/lib/factory/itemIdAttachment';
import createAttachmentFromLocalFileOperation from 'owa-service/lib/operation/createAttachmentFromLocalFileOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function createItemAttachment(
    item: Item,
    itemName: string,
    parentItemId: ItemId
): Promise<CreateAttachmentResponse> {
    const uninitializedAttachment: AttachmentType = {
        Name: null,
        ContentType: null,
        ContentId: null,
        ContentLocation: null,
        AttachmentOriginalUrl: null,
        Size: 0,
        LastModifiedTime: null,
        IsInline: false,
        IsInlineToUniqueBody: false,
        IsInlineToNormalBody: false,
        ThumbnailMimeType: null,
        Thumbnail: null,
    };

    const attachment = itemIdAttachment({
        Name: itemName,
        IsInline: false,
        ItemId: item.ItemId,
    });

    const attachmentTempId = itemName + '-' + new Date().toString();
    let attachments = item.Attachments || [];

    attachments = attachments.map(itemAttachment => {
        return itemIdAttachment({
            ...uninitializedAttachment,
            Name: itemAttachment.Name,
            AttachmentIdToAttach: itemAttachment.AttachmentId.Id,
            Size: itemAttachment.Size,
            ItemId: null,
            CreateAttachmentInlineType: CreateAttachmentInlineType.CopyFromSource,
        });
    });

    const requestBody = createAttachmentRequest({
        ParentItemId: parentItemId,
        Attachments: [attachment, ...attachments],
        RequireImageType: attachment.IsInline,
        IncludeContentIdInResponse: attachment.IsInline,
        ClientSupportsIrm: false,
        CancellationId: attachmentTempId,
    });

    const jsonRequest = createAttachmentJsonRequest({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    });

    return createAttachmentFromLocalFileOperation(jsonRequest).then(response => {
        return response;
    });
}
